export const ADDED_GROUPS_TO_PERSON = 'ADDED_GROUPS_TO_PERSON';
